<script>
  import TrendChart from './TrendChart.vue';

  export default {
    name: 'ErrorsPerMonth',
    extends: TrendChart,
    data() {
      return {
        chartId: 'errorsPerMonth',
        fields: [
          'num_errors',
        ],
      };
    },
  };
</script>
